import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { OpportunitiesShell } from "@/components/CandidateHeader";
import { Building2, MapPin, Loader2, Briefcase, ChevronRight } from "lucide-react";

export function CompanyLogo({ logo, name, size = 48 }) {
  return logo ? (
    <img src={logo} alt={name} style={{ height: size, width: size }} className="rounded-2xl object-cover border border-slate-200 flex-shrink-0" />
  ) : (
    <div style={{ height: size, width: size }} className="rounded-2xl bg-slate-100 flex items-center justify-center text-slate-300 flex-shrink-0"><Building2 size={size * 0.45} /></div>
  );
}

export default function CandidateCompanies() {
  const nav = useNavigate();
  const [companies, setCompanies] = useState(null);

  useEffect(() => {
    api.get("/candidate/companies").then((r) => setCompanies(r.data.companies)).catch(() => setCompanies([]));
  }, []);

  return (
    <OpportunitiesShell>
      <h1 className="font-head text-3xl font-bold tracking-tight">Firmy</h1>
      <p className="mt-2 text-slate-600">Firmy, ktoré používajú Profeeluj. Kliknutím zobrazíte ich profil a aktuálne ponuky.</p>

      {companies === null ? (
        <div className="flex justify-center py-20"><Loader2 className="animate-spin text-blue-700" /></div>
      ) : companies.length === 0 ? (
        <div className="mt-8 rounded-3xl border border-dashed border-slate-300 bg-white p-12 text-center">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100"><Building2 className="text-slate-400" /></div>
          <p className="mt-4 font-semibold text-slate-800">Zatiaľ žiadne firmy</p>
          <p className="text-sm text-slate-500 mt-1">Momentálne tu nie sú žiadne firmy s verejným profilom.</p>
        </div>
      ) : (
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="companies-list">
          {companies.map((c) => (
            <button key={c.id} data-testid={`company-card-${c.id}`} onClick={() => nav(`/app/companies/${c.id}`)}
              className="text-left rounded-3xl bg-white border border-slate-200 shadow-sm p-5 hover:shadow-md hover:border-blue-200 transition-all">
              <div className="flex items-start gap-3">
                <CompanyLogo logo={c.logo} name={c.name} />
                <div className="min-w-0 flex-1">
                  <h3 className="font-head font-semibold text-lg truncate">{c.name}</h3>
                  {c.location && <p className="text-sm text-slate-500 inline-flex items-center gap-1"><MapPin size={13} /> {c.location}</p>}
                </div>
                <ChevronRight className="text-slate-300 mt-1" size={18} />
              </div>
              {c.description && <p className="mt-3 text-sm text-slate-600 line-clamp-2">{c.description}</p>}
              <div className="mt-3">
                <span data-testid={`company-jobs-count-${c.id}`} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${c.open_jobs_count > 0 ? "bg-blue-50 border border-blue-100 text-blue-700" : "bg-slate-50 border border-slate-200 text-slate-500"}`}>
                  <Briefcase size={12} /> {c.open_jobs_count} {c.open_jobs_count === 1 ? "aktuálna ponuka" : "aktuálnych ponúk"}
                </span>
              </div>
            </button>
          ))}
        </div>
      )}
    </OpportunitiesShell>
  );
}
